<template>
    <div>
        <div class="card mb-3" id="provider-list">
            <div class="card-header headline customer">
                <h2 class="text-white d-inline">گزارش حسابهای مشتری</h2>
                <!--<button class="btn btn-secondary float-left" data-toggle="modal" data-target="#provider-modal"-->
                <!--@click="onModalButtonClicked">افزودن تامین کننده-->
                <!--</button>-->
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12 mb-3">
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                               v-model="searchString">
                    </div>
                    <div class="col-lg-12 mt-5" v-if="providers.length < 1">
                        <h3 class="text-center no-item-alert">تامین کننده ثبت نشده است!</h3>
                    </div>
                    <div class="col-lg-3 mb-3" v-for="(item, index) in providers">
                        <div class="card shadow" @click="onCardClicked(index)">
                            <div class="row p-2">
                                <!--<div class="col-lg-12">-->
                                <!--<img src="../../assets/img/placeholder.png" class="img-fluid w-100">-->
                                <!--</div>-->
                                <div class="col-lg-12 mt-3">
                                    <h4 class="text-center">{{item.outSourceName}}</h4>
                                    <span>مانده: </span>
                                    <span>{{item.remain<0 ? "(" + (item.remain*-1).toLocaleString() +"-)": item.remain.toLocaleString()}}</span>
                                    <br>
                                    <span>شماره تماس:</span>
                                    <span>{{item.phoneNumber}}</span>
                                    <br/>
                                    <span>کد ملی:</span>
                                    <span>{{item.branchCode}}</span>
                                    <br/>
                                    <span>توضیحات: </span>
                                    <span>{{item.description}}</span>
                                    <br>


                                </div>
                            </div>

                        </div>
                    </div>
                    <!--<div v-if="providers.length > 7 && lastRespond.length > 7" class="col-lg-12 text-center mb-3" @click="getproviders">
                        <button class="btn btn-success">نمایش حساب های بیشتر</button>
                    </div>-->
                    <div class="col-lg-12">
                        <div class="sk-circle" id="loading">
                            <div class="sk-circle1 sk-child"></div>
                            <div class="sk-circle2 sk-child"></div>
                            <div class="sk-circle3 sk-child"></div>
                            <div class="sk-circle4 sk-child"></div>
                            <div class="sk-circle5 sk-child"></div>
                            <div class="sk-circle6 sk-child"></div>
                            <div class="sk-circle7 sk-child"></div>
                            <div class="sk-circle8 sk-child"></div>
                            <div class="sk-circle9 sk-child"></div>
                            <div class="sk-circle10 sk-child"></div>
                            <div class="sk-circle11 sk-child"></div>
                            <div class="sk-circle12 sk-child"></div>
                        </div>
                    </div>
                    <div v-if="!autoload && providers.length < dataCount" class="col-lg-12 text-center my-3"                         >
                        <button class="btn btn-success" @click="getProviders">نمایش موارد بیشتر</button>
                        <div class="col-2 offset-5 my-2">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تعداد نمایش</span>
                                </div>
                                <input class="form-control" type="text" @change="changePageSize" v-model="queryParams.pageSize">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="provider-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 v-if="params.mode === 'create'" class="modal-title text-white">افزودن تامین کننده</h5>
                        <h5 v-if="params.mode === 'edit'" class="modal-title text-white">ویرایش تامین کننده</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <!--<div class="col-lg-6 offset-lg-3 mb-2">-->
                            <!--<div class="input-group">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">دسته بندی</span>-->
                            <!--</div>-->
                            <!--<vs-select :data="categories" :selected-val="preselectedCategory" :mode="'create'"-->
                            <!--:header="{multiple: false, label: 'name'}" @onChange="onCategoryChange"></vs-select>-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--<div class="col-lg-3 text-right">-->
                            <!--<button class="btn btn-primary bg-danger-grad border-0" @click="onAddCategoryClicked" data-toggle="tooltip" data-placement="bottom" title="افزودن دسته بندی">-->
                            <!--<i class="fa fa-plus"></i>-->
                            <!--</button>-->
                            <!--</div>-->
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام تامین کننده</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="provider.outSourceName">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره تماس</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="provider.phoneNumber">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد ملی</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="provider.branchCode">
                                </div>
                            </div>
                            <!--<div class="col-lg-4 mb-2">-->
                            <!--<div class="input-group">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">کد اقتصادی</span>-->
                            <!--</div>-->
                            <!--<input class="form-control" type="number" v-model="provider.shebaCode">-->
                            <!--</div>-->
                            <!--</div>-->
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد پستی</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="provider.accountNumber">
                                </div>
                            </div>
                            <div class="col-lg-12 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">آدرس</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="provider.address">
                                </div>
                            </div>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">توضیحات</span>
                            </div>
                            <input class="form-control" type="text" v-model="provider.description">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="col-7">
                            <button type="button" class="btn btn-warning mt-2" v-if="params.mode === 'edit'"
                                    @click="onProductsModalClicked">محصولات
                            </button>
                            <button v-if="params.mode === 'edit'" type="button" class="btn btn-success mt-2"
                                    data-dismiss="modal" @click="onTransactionModalClicked">گردش حساب
                            </button>
                        </div>
                        <div class="col-5">
                            <button type="button" class="btn btn-secondary mt-2" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-primary mt-2" @click="onModalOk">ذخیره</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="transactionModal" tabindex="-1" role="dialog" aria-labelledby="transactionTitle"
             aria-hidden="true" style="overflow-y: scroll">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-danger-grad glow-danger">
                        <h5 class="modal-title text-white" id="transactionTitle">گردش حساب</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="listView">
                            <div class="col-lg-12" v-for="(item, index) in transactions">
                                <div class="card list">
                                    <div class="row" @click="onCardClicked2(item.voucherId)">
                                        <!--<div class="col-md-3">-->
                                        <!--<strong>{{item.factor}}</strong>-->
                                        <!--</div>-->
                                        <!--<div class="col-md-3">-->
                                        <!--<strong>حساب: </strong>-->
                                        <!--<span>{{item.account}}</span>-->
                                        <!--</div>-->
                                        <div class="col-md-6">
                                            <strong>توضیحات: </strong>
                                            <span>{{item.description}}</span>
                                        </div>
                                        <div class="col-md-3">
                                            <strong>تاریخ: </strong>
                                            <span>{{item.persianDate}}</span>
                                        </div>
                                        <div class="col-md-3">
                                            <strong>مبلغ: </strong>
                                            <span v-if="item.creditor === 0 && item.debtor !== 0" class="text-success">{{item.debtor}} +</span>
                                            <span v-if="item.debtor === 0 && item.creditor !== 0" class="text-danger">{{item.creditor}} -</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-lg-6 product-container" v-for="(item, index) in transactions">
                                <div class="card transaction mt-2 mb-2">
                                    <div class="card-header">
                                        <h4 class="text-center">{{item.factor}}</h4>
                                    </div>
                                    <div class="card-body"  @click="onCardClicked2(item.voucherId)">
                                        <div class="text-center">
                                            <h5 class="d-inline">مبلغ: </h5>
                                            <h5 v-if="item.creditor === 0 && item.debtor !== 0"
                                                class="text-success d-inline">{{item.debtor}} +</h5>
                                            <h5 v-if="item.debtor === 0 && item.creditor !== 0"
                                                class="text-danger d-inline">{{item.creditor}} -</h5>
                                        </div>
                                        <span><b>حساب: </b></span>
                                        <span>{{item.account}}</span>
                                        <br>
                                        <span><b>توضیحات: </b></span>
                                        <span>{{item.description}}</span>
                                        <br>
                                        <span><b>تاریخ: </b></span>
                                        <span>{{item.persianDate}}</span>
                                        <br>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-lg-12 text-center">
                                <div v-if="transactions === undefined || transactions.length < 1" class="col-lg-12">
                                    <h3 class="no-item-alert text-center">رکوردی یافت نشد!</h3>
                                </div>
                                <div v-if="transactions !== undefined && transactions.length < transactionCount"
                                     class="col-lg-12 text-center" @click="getTransactions">
                                    <button class="btn btn-success">نمایش موارد بیشتر</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitle">محصولات فاکتور</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" id="printMe">
                        <div class="table-responsive">
                            <h5 class="text-center">فاکتور فروش</h5>
                            <h6 class="text-center" >
                                خریدار :
                                {{voucher.voucher !== undefined ?  voucher.voucher.receiveOutSourceName : ''}}
                                تاریخ :
                                {{ voucher.voucher !== undefined ?  voucher.voucher.persianDate : '' }}
                                سند شماره :
                                {{ voucher.voucher !== undefined ?  voucher.voucher.voucherNumber : ''}}
                                کاربر :
                                {{ voucher.voucher !== undefined ?  voucher.voucher.userFullName : ''}}
                            </h6>
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th class=" text-nowrap">نام محصول</th>
                                    <th class="text-center text-nowrap">تعداد</th>
                                    <th class="text-center text-nowrap">فی فروش</th>
                                    <th class="text-center  text-nowrap">تخفیف</th>
                                    <th class="text-center  text-nowrap">مالیات</th>
                                    <th class="text-center text-nowrap">جمع</th>
                                </tr>
                                </thead>
                                <tbody v-if="voucher !== undefined">
                                <tr v-for="(item,index) in voucher.products">
                                    <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                    <td>{{item.productName}}</td>
                                    <td class="text-center">
                                        {{item.unitVal}}
                                    </td>
                                    <td class="text-center">
                                        {{item.salesPrice.toLocaleString()}}
                                    </td>
                                    <td class="text-center">
                                        {{item.discount.toLocaleString()}}
                                    </td>
                                    <td class="text-center">
                                        {{item.taxPrice.toLocaleString()}}
                                    </td>
                                    <td class="text-center">
                                        {{(item.unitVal * item.salesPrice +item.taxPrice).toLocaleString()}}
                                    </td>
                                </tr>
                                <!--<tr>-->
                                    <!--<td class="text-left"><b>جمع</b></td>-->
                                    <!--<td class="text-center"><b>{{overallAmount.toLocaleString()}}</b></td>-->
                                    <!--<td class="text-center" v-if="voucher.voucher !== undefined">-->
                                        <!--<b>{{voucher.voucher.price.toLocaleString()}}</b>-->
                                    <!--</td>-->
                                    <!--<td class="text-center" v-if="voucher.voucher !== undefined">-->
                                        <!--<b>{{(voucher.voucher.totalDiscount).toLocaleString()}}</b>-->
                                    <!--</td>-->
                                    <!--<td class="text-center" v-if="voucher.voucher !== undefined">-->
                                        <!--<b>{{(voucher.voucher.price - voucher.voucher.totalDiscount).toLocaleString()}}</b>-->
                                    <!--</td>-->
                                <!--</tr>-->
                                </tbody>
                            </table>
                            <h4 class="text-center mt-5"
                                v-if=" voucher.products !== undefined && voucher.products.length < 1">محصولی ثبت
                                نشده است!</h4>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">تخفیف فاکتور</span>
                            </div>
                            <span v-if="voucher.voucher !== undefined" class="form-control text-right">{{voucher.voucher.discount.toLocaleString()}}</span>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">مالیات فاکتور</span>
                            </div>
                            <span class="form-control text-right">{{voucher.voucher !== undefined  && voucher.voucher.taxPrice !== undefined? voucher.voucher.taxPrice.toLocaleString() : 0}}</span>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">توضیحات</span>
                            </div>
                            <span v-if="voucher.voucher !== undefined" class="form-control text-right">{{voucher.voucher.description}}</span>
                        </div>
                        <div class="text-center w-100 p-3 text-bold">
                            <span>جمع فاکتور : </span>
                            <span v-if="voucher.voucher !== undefined">{{(parseInt(voucher.voucher.price)).toLocaleString()}}</span>
                            <span>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</span>
                            <span>مانده فاکتور : </span>
                            <span v-if="voucher.voucher !== undefined">{{(parseInt(parseInt(voucher.voucher.price) -  voucher.payments.reduce( (acc, itt) => { return acc += itt.price; }, 0))).toLocaleString()}}</span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <!--<div class="text-right w-100">-->
                            <!--<span>تاریخ سند: </span>-->
                            <!--<span v-if="voucher.voucher !== undefined">{{voucher.voucher.persianDate}}</span>-->
                        <!--</div>-->
                        <button type="button" class="d-inline-block btn btn-success m-1" @click="onPrintClicked"><i
                                class="fa fa-print"></i></button>
                        <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-secondary mr-1" @click="onPaymentClicked(voucher)"
                                v-if="voucher.voucher !== undefined && (parseInt(voucher.voucher.price) -  voucher.payments.reduce( (acc, itt) => { return acc += itt.price; }, 0)) > 0">
                            پرداخت
                        </button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>


<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect";
    import EventBus from "../../_framework/event-bus.js";
    import Moment from "moment-jalali";
    import VueHtmlToPaper from "vue-html-to-paper/src";

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });
    export default {
        name: 'report-customer',
        components: {VsSelect},
        data() {
            return {
                providers: [],
                categories: [],
                queryParams: {
                    pageSize: 12,
                    pageIndex: 0,
                    name: "",
                    types: 3
                },
                preselectedCategory: {},
                provider: {
                    phoneNumber: "",
                    description: "",
                    outSourceName: "",
                    type: 5
                },
                params: {
                    mode: 'create'
                },
                searchString: "",

                products: [],
                productSearchString: "",

                transactions: [],
                listView: true,
                transactionsQuery: {
                    pageSize: 8,
                    pageIndex: 0,
                    code: 0
                },
                dataCount: 0,
                transactionCount: 0,
                overallAmount: 0,

                autoload: false,
                onProClicked: false,
                voucher: {},


            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);


            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                this.providers = response.data.data;
                this.dataCount = response.data.count;
                $("#loading").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });

            new BaseService('categories').getAll().then(response => {
                this.categories = response.data;
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.providers.length < this.dataCount) {
                        $("#loading").show();
                        this.getProviders(-1);
                    }
                });
            }
        },
        methods: {
            changePageSize(e){
                this.getProviders(-1);
            },
            onPrintClicked(){
                this.$htmlToPaper('printMe');
            },
            getProviders(page) {
                if (page === -1) {
                    this.queryParams.pageIndex = 0;
                    this.vouchers = [];
                } else {
                    this.queryParams.pageIndex++;
                }
                $("#loading").show();
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.providers.push.apply(this.providers, response.data.data);
                    this.dataCount = response.data.count;
                    this.lastRespond = response.data.data;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                this.queryParams.pageIndex = 0;
                $("#loading").show();
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.providers = response.data.data;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onCardClicked(index) {
                if (!this.onProClicked) {
                    // $("#provider-modal").modal("show");
                    this.params.mode = 'edit';
                    this.provider = JSON.parse(JSON.stringify(this.providers[index]));
                    for (let item of this.categories) {
                        if (this.provider.categoryId === item.id) {
                            this.preselectedCategory = item;
                        }
                    }
                    this.onTransactionModalClicked();
                }
            },
            onCardClicked2(id) {
                this.overallAmount = 0;
                new BaseService('voucher', `/getproducts/${id}`).getList().then(response => {
                    this.voucher = response.data;
                    if (this.voucher.products.length >0) {
                        for (let item of this.voucher.products) {
                            this.overallAmount += item.unitVal;
                        }
                        $("#voucherData").modal("show");
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                })
            },
            onCategoryChange(e) {
                this.provider.categoryId = e.id;
            },
            onAddCategoryClicked() {
                $("#provider-modal").modal("hide");
                this.$router.push({name: 'category'});
            },
            onModalButtonClicked() {
                this.params.mode = 'create';
                Utils.resetObject(this.provider);
                this.preselectedCategory = {};
                this.provider.type = 5;
            },
            onModalOk() {
                if (this.params.mode === 'create') {
                    this.onCreate(this.provider);

                } else {
                    this.onUpdate(this.provider);
                }
            },
            onCreate(provider) {
                // console.log(provider)
                provider.rowVersion = this.generateUuid();
                new BaseService('outsource').create(provider).then(response => {
                    this.$noty.success("تامین کننده با موفقیت افزوده شد.");
                    $("#provider-modal").modal("hide");
                    this.queryParams.pageIndex = 0;
                    this.$router.push({
                        name: 'assign-product-to-provider',
                        params: {
                            id: response.data.data
                        }
                    });
                    // new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    //     this.providers = response.data.data;
                    //     $("#loading").hide();
                    //     Utils.resetObject(this.provider);
                    //     this.preselectedCategory = {};
                    //     this.provider.type = 5;
                    // }).catch(error => {
                    //     // error
                    //     Utils.handleErrorWithNotification(error.message, this.$noty);
                    // });
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onUpdate(provider) {
                new BaseService('outsource').update(provider).then(response => {
                    this.$noty.success("اطلاعات تامین کننده با موفقیت ویرایش شد.");
                    $("#provider-modal").modal("hide");
                    this.queryParams.pageIndex = 0;
                    new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                        this.providers = response.data.data;
                        $("#loading").hide();
                        Utils.resetObject(this.provider);
                        this.preselectedCategory = {};
                        this.provider.type = 5;
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onProductsModalClicked() {
                $("#provider-modal").modal("hide");
                this.$router.push({
                    name: 'assign-product-to-provider',
                    params: {
                        id: this.provider.id
                    }
                });
            },
            onProductsModalClicked2(id) {
                // $("#provider-modal").modal("show");
                // $("#provider-modal").modal("hide");
                this.onProClicked = true;
                this.$router.push({
                    name: 'assign-product-to-provider',
                    params: {
                        id: id
                    }
                });
            },
            onTransactionModalClicked() {
                $("#transactionModal").modal('show');
                this.transactionsQuery.code = this.provider.code;
                this.transactionsQuery.pageIndex = 0;
                new BaseService('reports', '/gettransactionreport').getList(this.transactionsQuery).then(response => {
                    this.transactions = response.data.data;
                    this.transactionCount = response.data.count;
                    if (this.transactions !== undefined) {
                        for (let item of this.transactions) {
                            item.persianDate = Moment(item.date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        }
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            getTransactions() {
                this.transactionsQuery.pageIndex++;
                new BaseService('reports', '/gettransactionreport').getList(this.transactionsQuery).then(response => {
                    this.transactions.push.apply(this.transactions, response.data.data);
                    for (let item of this.transactions) {
                        item.persianDate = Moment(item.date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },


        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#provider-modal").hasClass("show")) {
                $("#provider-modal").modal("hide");
                next(false);
            } else {
                if ($("#transactionModal").hasClass("show")) {
                    $("#transactionModal").modal("hide");
                    next(false);
                } else {
                    if ($("#voucherData").hasClass("show")) {
                        $("#voucherData").modal("hide");
                        next(false);
                    } else {
                        next();
                    }
                }
            }


        },
    }
</script>